<template>
<div class="mark-preview">
    <div v-html="marked(content)"></div>
    <div class="text-pad"><slot></slot></div>
</div>
</template>

<script type="text/javascript">
import markdown from 'marked'
import highlight from 'light.js'

const light = highlight.Highlight

export default {
    props: {
        content: {
            type: String,
            default: '',
            sync: true
        }
    },
    mounted() {
        var pad = this.$el.querySelector('.text-pad');
        var text = pad.innerHTML
        if (!this.content && text) {
            text = text.replace(/\ {6,}/g, '')
            pad.innerHTML = this.marked(text)
        }
    },
    methods: {
        marked (value) {
            var $vm = this
            if (window.hljs) {
                setTimeout(()=> {
                    this.highlight()
                }, 100);
            }
            return markdown.parse(value)
        },
        highlight () {
            const codes = this.$el.querySelectorAll('.mark-preview pre code')
            if (codes && codes.length) {
                for (let code of codes) {
                    hljs.highlightBlock(code)
                }
            }
        }
    }
}

</script>

<style type="text/css" lang="less">
.mark-preview {
    h1,h2,h3,h4 {
        font-weight: bold;
        font-size: 1.5em;
        line-height: 1.5em;
        padding: 10px;
        margin: 10px 0;
    }

    h1 {
        font-size: 3em;
        border-left: 3px solid lightblue;
        background-color: #EEE;
    }

    h2 {
        font-size: 2em;
        border-left: 3px solid lightblue;
        background-color: #EEE;
    }

    pre {
        padding: 10px;
        background: rgba(255, 255, 255, 0.7) !important;
        margin: 10px 0;
        border: 1px solid #EEE;
        border-left: 5px solid #EEE;
    }
    
    blockquote {
        border: 1px solid #EEE;
        border-radius: 2px;
        padding: 10px;
    }

    ul {
        margin-left: 2em;
    }
    li {
        list-style-type: square;
    }
    
    pre code {
        background-color: #FFF;
        border: none;
        margin: 0 2px;
    }
}
</style>


// WEBPACK FOOTER //
// MarkPreview.vue?4cca05c0